import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { connectionsReducer } from './connections';
const rootReducer = combineReducers({
    connectionsState: connectionsReducer
});
const store = configureStore({
    reducer: rootReducer,
});
export default store;
